<template>
  <aside class="introduction-page">
    <DocumentPageTitle
      :word-count="totalWords"
      :word-limit="wordLimit"
      title="Introduction"
    />

    <TextEditorInput
      v-for="storeItem in storeItems"
      :id="storeItem.id"
      :key="storeItem.id"
      v-model="planContentKey[storeItem.storeKey]"
      :label="storeItem.label"
      :word-limit="wordLimit"
      :total-word-count="totalWords"
      @update:word-count="handleWordCountUpdate"
    />
  </aside>
</template>

<script setup>
import { usePlanStore } from '@/store';
import { DocumentPageTitle } from '@/components/plan-document/components';
import { TextEditorInput } from '@/components/form-inputs';
import { useString, useTinyMCEWordCount } from '@/composables';
import { computed } from 'vue';

const planStore = usePlanStore();
const string = useString();

const wordLimit = 3000;

const planContentKey = computed(() => {
  return planStore.content?.introduction || null;
});

const storeItems = [
  { storeKey: 'introduction', label: '' },
  { storeKey: 'powersAndFunctions', label: 'Powers and functions' },
].map(storeItem => ({ ...storeItem, id: string.sluggify(storeItem.label) }));

const storeItemIds = storeItems.map(storeItem => storeItem.id);

const {
  totalWords,
  updateCount,
} = useTinyMCEWordCount(wordLimit, storeItemIds);

const handleWordCountUpdate = ({ id, count }) => {
  updateCount(id, count);
};
</script>
